/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface Calculator
 */
export interface Calculator {
  /**
   *
   * @type {number}
   * @memberof Calculator
   */
  readonly id: number
  /**
   *
   * @type {any}
   * @memberof Calculator
   */
  structure?: any | null
  /**
   *
   * @type {boolean}
   * @memberof Calculator
   */
  usedDefault?: boolean
  /**
   * * `service` - service
   * * `static_page` - static_page
   * @type {string}
   * @memberof Calculator
   */
  type: CalculatorTypeEnum
  /**
   *
   * @type {number}
   * @memberof Calculator
   */
  entityId?: number | null
  /**
   *
   * @type {number}
   * @memberof Calculator
   */
  serviceTemplateType?: number
}

/**
 * @export
 */
export const CalculatorTypeEnum = {
  Service: 'service',
  StaticPage: 'static_page',
} as const
export type CalculatorTypeEnum = (typeof CalculatorTypeEnum)[keyof typeof CalculatorTypeEnum]

/**
 * Check if a given object implements the Calculator interface.
 */
export function instanceOfCalculator(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'id' in value
  isInstance = isInstance && 'type' in value

  return isInstance
}

export function CalculatorFromJSON(json: any): Calculator {
  return CalculatorFromJSONTyped(json, false)
}

export function CalculatorFromJSONTyped(json: any, ignoreDiscriminator: boolean): Calculator {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: json['id'],
    structure: !exists(json, 'structure') ? undefined : json['structure'],
    usedDefault: !exists(json, 'usedDefault') ? undefined : json['usedDefault'],
    type: json['type'],
    entityId: !exists(json, 'entityId') ? undefined : json['entityId'],
    serviceTemplateType: !exists(json, 'serviceTemplateType')
      ? undefined
      : json['serviceTemplateType'],
  }
}

export function CalculatorToJSON(value?: Calculator | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    structure: value.structure,
    usedDefault: value.usedDefault,
    type: value.type,
    entityId: value.entityId,
    serviceTemplateType: value.serviceTemplateType,
  }
}
